
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import React from 'react'

const generatePieChartConfig = () => {
  const data = [
    { name: 'Apples', y: 5, color: '#7060FF' },
    { name: 'Oranges', y: 3, color: '#F06F2D' },
    { name: 'Bananas', y: 2, color: '#FBC01C' },
    { name: 'Grapes', y: 4, color: '#1ECA52' },
    { name: 'Pears', y: 1, color: '#592E83' },
  ];

  return {
    chart: {
      type: 'pie',
      backgroundColor: '#191C23',
    },
    title: {
      text: 'My Pie Chart',
      style: {
        color: '#FFFFFF',
      },
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        innerSize : '80%',
        borderColor : 'null'
      },
    },
    series: [
      {
        name: 'My Data',
        data,
      },
    ],
    legend: {
      align: 'right',
      verticalAlign: 'middle',
      layout: 'vertical',
      labelFormat: '{name}: <span style="color:{color}">{y} ({percentage:.1f}%)</span>',
      itemMarginTop: 10,
      itemMarginBottom: 10,
      itemStyle: {
        fontSize: '12px',
        fontWeight: 'normal',
        color: '#FFFFFF',
      },
    },
  };
};

  
  const Circlechart = () => {
    return (
      <div>
        <HighchartsReact
          highcharts={Highcharts}
          options={generatePieChartConfig()}
        />
      </div>
    );
  };
  
  
  export default Circlechart;
  
  